/**
 * SubtitleModeToggle
 * 
 * 职责：字幕显示模式切换按钮（全/原/译），使用上下两条杠的图标表达当前模式
 */

import React from 'react';

interface SubtitleModeToggleProps {
  label: string;
  disabled: boolean;
  onClick: () => void;
}

export const SubtitleModeToggle: React.FC<SubtitleModeToggleProps> = ({
  label,
  disabled,
  onClick,
}) => {
  // 根据 label 判断当前模式：全（both）/ 原（original）/ 译（translated）
  const isBoth = label === '全';
  const isOriginal = label === '原';
  const isTranslated = label === '译';

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };

  return (
    <button
      className="control-button subtitle-mode-toggle"
      disabled={disabled}
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      aria-label="切换字幕显示模式"
      title="切换字幕显示模式：全部/原文/翻译"
    >
      {/* 使用上下两条杠的图标来表示当前模式 */}
      <span className="subtitle-mode-icon" aria-hidden="true">
        <span
          className={
            'subtitle-mode-bar subtitle-mode-bar-top' +
            ((isBoth || isOriginal) ? ' active' : '')
          }
        />
        <span
          className={
            'subtitle-mode-bar subtitle-mode-bar-bottom' +
            ((isBoth || isTranslated) ? ' active' : '')
          }
        />
      </span>
      {/* 保留文字标签用于无障碍和未来扩展，但不作为主要视觉元素 */}
      <span className="subtitle-mode-label-visually-hidden">{label}</span>
    </button>
  );
};

